<template>
    <div>
        <v-card class="box">
            <v-row justify="center">
                <v-radio-group v-model="print_type" row>
                    <v-radio label="Print Bulk Icards" value="Bulk"></v-radio>
                    <v-radio label="Print Specific Icards" value="Specific"></v-radio>
                </v-radio-group>
            </v-row>

            <template v-if="print_type == 'Bulk'">
                <div :key="'bulk-' + print_type">
                    <v-row dense justify="center">
                        <v-col sm="3" md="3">
                            <v-autocomplete class="no-display" :items="std_list" item-value="id" item-text="standard"
                                v-model="std" label="Search Standard" dense rounded outlined
                                color="#0F2027"></v-autocomplete>
                        </v-col>
                        <v-col sm="3" md="3">
                            <v-autocomplete class="no-display" :items="div_list" item-value="id" item-text="division"
                                v-model="div" label="Search Division" dense rounded outlined
                                color="#0F2027"></v-autocomplete>
                        </v-col>
                        <v-col sm="2">
                            <v-autocomplete color="#0F2027" dense rounded required v-model="status" :items="status_list"
                                item-text="name" item-value="id" label="Status" outlined persistent-hint
                                hint="Select Status" />
                        </v-col>
                    </v-row>
                    <v-row v-if="std && div && status" dense justify="center">
                        <v-col sm="2" md="2">
                            <v-btn color="primary" @click="bulk">Proceed to <span class="i-card">bulk</span>
                                print</v-btn>
                        </v-col>
                    </v-row>
                </div>
            </template>
            <template v-if="print_type == 'Specific'">
                <div :key="'specific-' + print_type">
                    <v-row justify="center">
                        <v-col cols="12" sm="5">
                            <v-autocomplete v-model="selectedStudents" :items="stud_list" item-text="name" :loading="comp_load"
                                item-value="lid" label="Students" multiple chips outlined dense>

                                <template v-slot:selection="{ item, index }">
                                    <v-chip v-if="index === 0">
                                        <span>{{ item.name }}</span>
                                    </v-chip>
                                    <span v-if="index === 1" class="grey--text text-caption">
                                        (+{{ selectedStudents.length - 1 }} others)
                                    </span>
                                </template>

                                <template v-slot:prepend-item>
                                    <v-list-item @mousedown.prevent>
                                        <v-list-item-action>
                                            <v-checkbox v-model="selected_all_students" @change="toggle_student">
                                                <template #label>
                                                    <span class="ml-8">Select All</span>
                                                </template>
                                            </v-checkbox>
                                        </v-list-item-action>
                                    </v-list-item>
                                    <v-divider class="mt-2"></v-divider>
                                </template>

                            </v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="3" md="3">
                            <v-btn :loading="loader" color="primary" @click="getStudentIcardSpecificPRN">Proceed to Student <span
                                    class="i-card"> Icard </span>
                                print</v-btn>
                        </v-col>
                    </v-row>
                    <!-- <v-row justify="center" dense>
                    <v-col sm="5">
                        <v-textarea v-model="prn" color="#0F2027" rounded dense label="Enter Comma Seperated PRN"
                            outlined></v-textarea>
                    </v-col>
                </v-row>
                <v-row justify="center" dense>
                    <v-col sm="3" v-if="prn">
                        <v-btn color="primary" @click="getStudentIcardSpecificPRN()">Proceed To <span class="i-card">
                                Student</span>Icard print</v-btn>
                    </v-col>
                </v-row> -->
                </div>
            </template>
        </v-card>
    </div>
</template>
<script>
import axios from "axios";
import VueBarcode from "vue-barcode";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
    components: {
        barcode: VueBarcode,
    },
    data: () => ({
        comp_load: false,
        stud_list: [],
        radios: null,
        stud_data: null,
        child_data: null,
        icard_data: [],
        common_data: [],
        print_type: null,
        std_list: null,
        div_list: null,
        std: null,
        div: null,
        status_list: [
            { name: "Active", id: "0" },
            { name: "Temporary Inactive", id: "1" },
            { name: "Permanent Inactive", id: "2" },
        ],
        status: "0",
        active_status: null,
        prn: null,
        selectedStudents: [],
        selected_all_students: false,
        loader: false,
    }),
    mounted() {
        this.onload();
        localStorage.setItem("icard_std_id", null);
        localStorage.setItem("icard_div_id", null);
    },
    watch: {
        selectedStudents(val) {
            this.selected_all_students =
                this.stud_list.length > 0 &&
                val.length === this.stud_list.length;
        },

        print_type() {
            this.selectedStudents = [];
            this.selected_all_students = false;
            this.std = null;
            this.div = null;
            this.status = "0";
        }
    },
    methods: {
        selectAllStudents(selected) {
            if (selected.includes("all")) {
                this.student = this.stud_list.map((s) => s.lid); 
                this.selectedAll = true;
                console.log(
                    "selected " +
                    selected.length +
                    " student " +
                    this.stud_list.length +
                    " sel_imp " +
                    this.student.length
                );
                if (selected.length == this.student.length - 1) {
                    this.student = selected;
                    this.student = this.student.filter((id) => id != "all");
                    this.selectedAll = false;
                }
            }
            if (
                selected.length == this.stud_list.length - 1 &&
                !selected.includes("all") &&
                this.selectedAll
            ) {
                this.student = [];
                this.selectedAll = false;
            } else if (
                selected.length == this.stud_list.length - 1 &&
                !selected.includes("all")
            ) {
                this.student.push("all");
                this.selectedAll = true;
            }
        },
        toggle_student() {
            if (!this.stud_list.length) return;

            this.$nextTick(() => {
                if (this.selected_all_students) {
                    this.selectedStudents = this.stud_list.map(
                        stud => stud.lid
                    );
                } else {
                    this.selectedStudents = [];
                }
            });
        },
        getStudentIcardSpecificPRN() {
            const data = {
                for: "specific",
                usertype: "Student",
                learners: this.stud_list
                    .filter((stud) => this.selectedStudents.includes(stud.lid))
                    .map((stud) => stud.prn)
                    .join(","),
            };
            this.overlay = true;
            this.loader = true;
            if (this.selectedStudents.length == 0) {
                this.showSnackbar("red", "Please Select Student(s) !!!");
                return;
            }
            axios
                .post("/Icard/generateIcardCommon", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.icard_data = res.data.icard_data;
                        // this.inst_data = res.data.inst_data;
                        this.common_data = res.data.common_data;
                        localStorage.setItem("icard_data", JSON.stringify(this.icard_data));
                        localStorage.setItem("common_data", JSON.stringify(this.common_data));
                        let routeData = this.$router.resolve({
                            name: "zeal-specific-card-print",
                        });
                        window.open(routeData.href, "_blank");
                        this.loader = false;

                    } else {
                        alert(res.data.snackbar);
                    }
                    this.overlay = false;
                    this.loader = false;
                })

                .catch((error) => {
                    console.log("Error", error);
                    alert("Somthing went wrong!!!");
                    this.overlay = false;
                })
                .finally(() => {
                    this.comp_load = false;
                });
        },
        bulk() {
            localStorage.setItem("icard_std_id", this.std);
            localStorage.setItem("icard_div_id", this.div);
            localStorage.setItem("icard_learner_status", this.status);
            let routeData = this.$router.resolve({
                name: "zeal-stud-bulk-card-print",
            });
            window.open(routeData.href, "_blank");
        },
        // getStudentIcardSpecificPRN() {
        //     localStorage.setItem("prn", JSON.stringify(this.prn));
        //     let routeData = this.$router.resolve({
        //         name: "zeal-specific-card-print",
        //     });
        //     window.open(routeData.href, "_blank");
        // },
        print() {
            this.$store.state.drawer = false;
            let that = this;
            window.onafterprint = function () {
                that.$store.state.drawer = true;
            };
            setTimeout(function () {
                window.print();
            }, 100);
        },
        onload() {
            this.comp_load = true;
            axios
                .post("/admission/getAllStudents1")
                .then((res) => {
                    if (res.data.msg == "200") {
                        this.stud_list = res.data.stud_list;
                        this.std_list = res.data.std_list;
                        this.div_list = res.data.div_list;
                    } else {
                        alert("Somthing went wrong!!!");
                    }
                })
                .catch((error) => {
                    alert("Somthing went wrong!!!");
                })
                .finally(() => {
                    this.comp_load = false;
                });
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
    },
};
</script>

<style scoped>
wrap {
    align-self: flex-end;
}

h2 {
    font-size: 1.2em;
}

tr,
td {
    width: 100%;
}

th {
    text-align: left;
    font-size: 0.7em;
    padding-right: 15px;
    padding-left: 6px;
}

@media print {
    .pagebreak {
        page-break-before: always;
    }

    header,
    footer,
    nav,
    date {
        display: none !important;
        margin-top: none !important;
    }

    .no-display,
    .v-input__control,
    input[type="button"],
    input[type="submit"],
    input[type="reset"],
    #v-card {
        display: none !important;
        margin-top: none !important;
    }

    v-card {
        border: none !important;
        margin-top: none !important;
    }

    * {
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
    }

    @page {
        size: A4;
        margin-top: none !important;
        padding-top: none !important;
        size: 15.5in 15.5in;
    }
}

.box1 {
    border: 2px solid black;
}

.box2 {
    border: 2px solid black;
    height: 35rem;
}

.empimg {
    margin-bottom: 20px;
}

.schlname {
    font-size: large;
    font-weight: bold;
}

.schladdr {
    font-weight: bold;
    font-size: 12px;
}

.schlphone {
    font-weight: bold;
    font-size: 12px;
}

.ay {
    font-size: 13px;
    writing-mode: vertical-lr;
    transform: rotate(-180deg);
    -ms-transform: rotate(-180deg);
    /*  for IE  */
    -webkit-transform: rotate(-180deg);
    display: inline-block;

    margin-top: 240px;
    margin-bottom: -75px;
    margin-left: 32px;
    text-transform: uppercase;
}

.clgname {
    writing-mode: vertical-lr;
    transform: rotate(-180deg);
    -ms-transform: rotate(-180deg);
    /*  for IE  */
    -webkit-transform: rotate(-180deg);
    display: inline-block;
    font-size: 35px;
    margin-top: -125px;
    margin-left: -12px;
    text-transform: uppercase;
}

.barcoded {
    margin-bottom: -26px;
    margin-top: 25px;
}

.signature {
    width: 38%;
    height: 45px;
    margin-bottom: 13px;
    margin-right: -78px;
}

.bgimg {
    background-color: white;

    height: 50%;
}

.secondarySection {
    background-color: blue;
    color: white;
    height: 34rem;
}

.primarySection {
    background-color: red;
    color: white;
    height: 34rem;
}

.priSection {
    background-color: yellow;
    color: black;
    height: 34rem;
}

.Section {
    background-color: red;
    color: white;
    height: 34rem;
}

ul.inst {
    list-style-type: "*";
    font-weight: 500;
    font-size: 14px;
}

.ss_clgname {
    transform: rotate(180deg);
    -ms-transform: rotate(180deg);
    /*  for IE  */
    -webkit-transform: rotate(180deg);
    writing-mode: vertical-lr;
    font-size: 30px;
    transform-origin: center center;
    margin-top: 7.5rem;
    margin-right: 1px;
    text-transform: uppercase;
}

.ps_clgname {
    transform: rotate(180deg);
    -ms-transform: rotate(180deg);
    /*  for IE  */
    -webkit-transform: rotate(180deg);
    writing-mode: vertical-lr;
    font-size: 30px;
    transform-origin: center center;
    margin-top: 9.5rem;
    margin-right: 1px;
    text-transform: uppercase;
}

.pps_clgname {
    transform: rotate(180deg);
    -ms-transform: rotate(180deg);
    /*  for IE  */
    -webkit-transform: rotate(180deg);
    writing-mode: vertical-lr;
    font-size: 30px;
    transform-origin: center center;
    margin-top: 6.4rem;
    margin-right: 1px;
    text-transform: uppercase;
}

.qrcode_dems {
    width: 45%;
    height: auto;
}

.qrcode_scs {
    width: 50%;
    height: auto;
    margin-top: 1rem;
}

.qrcode_zis {
    width: 50%;
    height: auto;
    margin-top: 1rem;
}

.sign_dems {
    width: 118px;
    height: auto;
    margin-top: 1rem;
}

.sign_scs {
    width: 104px;
    height: auto;
    margin-top: 1rem;
}

.sign_zis {
    width: 150px;
    height: auto;
    padding-left: 1rem;
}

.i-card {
    color: greenyellow;
    font-size: medium;
    margin-left: 2px;
    margin-right: 2px;
}
</style>
